import { Configurator } from "./components/Configurator";

export default function App() {
  return (
    <>
      <Configurator />
      {/* <CookieBannerComponent
        imprintHref="https://2d.o7ean.de/impressum"
        privacyPolicyHref="https://2d.o7ean.de/datenschutz"
        cookieDetailsHref="#"
      /> */}
    </>
  );
}
